import { service, service1 } from "@/request/request";

//登录接口
export const userLogin = (data) => {
  return service({
    url: "/login",
    method: "post",
    data: data,
  });
};
export const captchaImage = (data) => {
  return service({
    url: "/captchaImage",
    method: "get",
    data: data,
  });
};
export const getInfo = (data) => {
  return service1({
    url: "/user/getInfo",
    method: "get",
    data: data,
    apiCrypto: true,
  });
};

//发送手机验证码
export const getSmsCode = (data) => {
  return service({
    url: "/smsCode",
    method: "post",
    data: data,
  });
};

//重置密码
export const resetPwd = (data) => {
  return service({
    url: "/resetPwd",
    method: "post",
    data: data,
  });
};

//注销账号
export const loginOff = (data) => {
  return service1({
    url: "/loginOff",
    method: "post",
    data: data,
  });
};

//记录登录积分
export const loginCredit = (data) => {
  return service1({
    url: "/loginCredit",
    method: "get",
    params: data,
  });
};
